import { is } from 'bpmn-js/lib/util/ModelUtil';
import { openLightbox } from './ImageGroup';

/**
 * Adds a small image indicator overlay (🖼) to Task elements
 * on the canvas when they have a custom:imageUrl set.
 * Includes a dashed connector line and opens lightbox on click.
 */

function createOverlayHtml(imageUrl, element) {
  const badge = document.createElement('div');
  badge.className = 'image-indicator-badge';
  badge.title = 'Klicken zum Vergrößern';
  badge.textContent = '🖼';
  badge.addEventListener('click', function(e) {
    e.stopPropagation();
    openLightbox(imageUrl, element);
  });

  return badge;
}

export default function ImageOverlayProvider(eventBus, overlays, elementRegistry) {
  const overlayMap = {};

  function updateOverlay(element) {
    // Only handle Task elements
    if (!element?.businessObject || !is(element, 'bpmn:Task')) {
      return;
    }

    const elementId = element.id;

    // Remove existing overlay
    if (overlayMap[elementId]) {
      try {
        overlays.remove(overlayMap[elementId]);
      } catch {
        // overlay may already be removed
      }
      delete overlayMap[elementId];
    }

    const imageUrl = element.businessObject.get('custom:imageUrl');
    if (imageUrl) {
      try {
        overlayMap[elementId] = overlays.add(element, 'image-indicator', {
          position: {
            top: 4,
            right: 4
          },
          html: createOverlayHtml(imageUrl, element),
          show: {
            minZoom: 0.3
          },
          scale: {
            min: 1,
            max: 1
          }
        });
      } catch (e) {
        console.warn('Could not add image overlay:', e);
      }
    }
  }

  function updateAll() {
    elementRegistry.forEach(function(element) {
      updateOverlay(element);
    });
  }

  // Update overlay when individual element changes
  eventBus.on('element.changed', function(event) {
    updateOverlay(event.element);
  });

  // After XML import, set overlays on all elements
  eventBus.on('import.done', function() {
    updateAll();
  });

  // After undo/redo, refresh all overlays
  eventBus.on('commandStack.changed', function() {
    updateAll();
  });
}

ImageOverlayProvider.$inject = ['eventBus', 'overlays', 'elementRegistry'];
